// extracted by mini-css-extract-plugin
module.exports = {"search-input":"search_search-input__jR9u6","select":"search_select__zqqfa"};